import type { Lead } from '../../../../shared/types';
import { OPEN_STAGES, summarizeLeadStages } from '../../logic/leadStages';
import { section } from '../../ui/components';
import { h, span } from '../../ui/dom';
import { STAGE_LABELS } from '../../ui/labels';
import { cardLink } from '../home/cardLink';

/** Open current-stage rows sum to the Pipeline badge. Won is separate. */
export const pipelineCard = (leads: readonly Lead[]): HTMLElement => {
  const summary = summarizeLeadStages(leads);
  const counts = OPEN_STAGES.map((stage) => ({ stage, count: summary.current[stage] }));
  const max = Math.max(1, ...counts.map((c) => c.count));
  return section(
    { title: 'Pipeline · open', count: summary.open, action: cardLink('Open', '#/pipeline') },
    h('p', { class: 'card__note' }, 'Current stage · excludes Won and Lost'),
    h(
      'div',
      { class: 'stagebars' },
      counts.map((c) =>
        h(
          'a',
          { class: 'stagebar', href: '#/pipeline' },
          span('stagebar__label', STAGE_LABELS[c.stage]),
          h(
            'span',
            { class: 'stagebar__track' },
            h('span', { class: 'stagebar__fill', style: { width: `${(100 * c.count) / max}%` } }),
          ),
          span('stagebar__value mono', String(c.count)),
        ),
      ),
    ),
    h('p', { class: 'card__note' }, `Won · closed leads: ${summary.current.closed_won}`),
  );
};
